export const NameValidationConfig = {
  MAX_RETRY_LIMIT: 5,
  SHORT_ID_LENGTH: 4,
  LONG_ID_LENGTH: 20
}
